import React from "react";
import { Modal ,Row , Col} from "antd";
import PropTypes from "prop-types";


export default class ConfirmationActionModal extends React.Component{
    render(){
        return(
            <Modal
                title={this.props.modalTitle}
                visible={this.props.visible}
                destroyOnClose={true}
                onOk={this.props.onModalConfirm}
                onCancel={this.props.onModalCancel}
                closable
                maskClosable
            >
                <div dangerouslySetInnerHTML={{__html: this.props.contentHead}}></div>
                {this.props.schemeSelectedDetails && this.props.schemeSelectedDetails.map((_ , k) => (
                    <Row key={k}>
                        <Col span={8}>
                            <label>{_.seller.name} : </label>
                        </Col>
                        <Col span={16}>
                            <label>{_.scheme_name}</label>
                        </Col>
                    </Row>))}
                <div dangerouslySetInnerHTML={{__html: this.props.modalBottomContent}}></div>
            </Modal>
        );
    }
}
ConfirmationActionModal.propTypes = {
    modalTitle : PropTypes.string,
    modalBottomContent : PropTypes.string,
    visible : PropTypes.bool,
    onModalCancel : PropTypes.func,
    contentHead : PropTypes.string,
    schemeSelectedDetails : PropTypes.array,
    onModalConfirm : PropTypes.func
};